export default __webpack_public_path__ + "alberta-sort-a-to-z.4e602898f6bdd4bc24e1.svg";